angular.module('lf.common')

.factory('wishlistService', function ($http, $rootScope, preloadData) {
  
  var wishlistService = {
    
    add: function (params) {
      // params.id, params.skuId
      // $http invocation returns Promise
      
      var product = params.product;
      var postUrl = product.siteBaseUrl ? product.siteBaseUrl + preloadData.shopActionPath : preloadData.shopAction;
      
      return $http({
        method: 'POST',
        url: postUrl,
        params: {
          // all ATG fields here + product specific
          atg_giftlistId: preloadData.user.wishlistId,
          atg_productId: product.id,
          atg_catalogRefIds: '[' + product.skuId + ']',
          atg_removalCatalogRefIds: product.cartItemId ? '[' + product.cartItemId + ']' : null,
          atg_quantity: '1',
          atg_siteId: product.siteId ? product.siteId : lf.data.xhr.siteId,
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'addItemsToGiftlist',
          amplifiHandler: '/atg/commerce/gifts/GiftlistFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.shop = data.data.shop;
          $rootScope.$broadcast('wishlist:add', params.product);
        });
      
    },
    
    remove: function (params) {
      
      var product = params.product;
      
      return $http({
        method: 'POST',
        url: product.siteBaseUrl + preloadData.shopActionPath,
        params: {
          // all ATG fields here + product specific
          atg_giftlistId: preloadData.user.wishlistId,
          atg_removeGiftitemIds: '[' + product.wishlistItemId + ']',
          atg_siteId: product.siteId,
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'removeItemsFromGiftlist',
          amplifiHandler: '/atg/commerce/gifts/GiftlistFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.shop = data.data.shop;
          $rootScope.$broadcast('wishlist:remove', params.product);
        });
    },
    
    addToCart: function (params) {
      // params.id, params.skuId
      // $http invocation returns Promise
      
      var product = params.product;
    	
      return $http({
        method: 'POST',
        url: product.siteBaseUrl + preloadData.shopActionPath,
        params: {
          // all ATG fields here + product specific
          atg_giftlistId: preloadData.user.wishlistId,
          atg_giftlistItemId: product.wishlistItemId,
          atg_siteId: product.siteId,
          getData: 'shoppingActionResponse',
          updateData: 'true',
          action: 'addItemToOrder',
          amplifiHandler: '/atg/commerce/gifts/GiftlistFormHandler'
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.shop = data.data.shop;
          $rootScope.$broadcast('cart:add', params.product);
        });
      
    },
    
    getItemsCount: function () {
      return $rootScope.shop.wishlist.items.length;
    },
    
    emailWishlist: function (params) {
      var postParams = {
        'atg_lfWishlistEmailForm.data.wishlistEmailFrom.value': preloadData.user.login,
        'atg_lfWishlistEmailForm.data.wishlistEmailTo.value': params.emailTo,
        'atg_lfWishlistEmailForm.data.wishlistEmailNote.value': params.emailNote,
        atg_sendMeACopy: params.sendMeACopy,
        atg_giftlistId: preloadData.user.wishlistId,
        getData: 'formHandlerResponse',
        updateData: 'true',
        action: 'emailGiftlist',
        amplifiHandler: '/atg/commerce/gifts/GiftlistFormHandler'
      };
      
      if (params.product) {
        postParams.atg_giftlistItemId = params.product.wishlistItemId,
        postParams.atg_productItemId = params.product.id,
        postParams.atg_creationDate = params.product.dateAdded
      }
      
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        params: postParams,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('wishlist:emailSent', params);
        });
    },
    
    getByType: function (type) {
      return $rootScope.shop.wishlist.items.filter(function (item) {
        return item.type === type;
      });
    },
    
    getHardgoods: function () {
      return wishlistService.getByType('hardgoods');
    },
    
    getSoftgoods: function () {
      return wishlistService.getByType('softgoods');
    }
  }
  
  return wishlistService;
  
});
